import { render, staticRenderFns } from "./app_recipient_badge.vue?vue&type=template&id=0e3fe6ea"
import script from "./app_recipient_badge.vue?vue&type=script&lang=js"
export * from "./app_recipient_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports